/* VFW Inspiration gallery.
   One dimension only — platform — on the same chip control the Shop All
   Wheels page uses. James, 2026-09-21: most visitors own one car, so the job
   is "show me mine", not a query builder. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.inspirationReady) return;
    root.dataset.inspirationReady = 'true';
    var grid = root.querySelector('[data-insp-grid]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.vfw-insp__item'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-insp-chip]'));
    var countEl = root.querySelector('[data-insp-count]');
    var emptyEl = root.querySelector('[data-insp-empty]');

    function apply(value, updateUrl) {
      if (!chips.some(function (c) { return c.getAttribute('data-insp-chip') === value; })) value = '';
      var shown = 0;
      items.forEach(function (li) {
        var ok = !value || li.getAttribute('data-platform') === value;
        li.hidden = !ok;
        if (ok) shown++;
      });

      chips.forEach(function (c) {
        var on = c.getAttribute('data-insp-chip') === value;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (countEl) countEl.textContent = String(shown);
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (updateUrl) {
        var url = new URL(window.location.href);
        if (value) url.searchParams.set('vehicle', value);
        else url.searchParams.delete('vehicle');
        window.history.pushState(null, '', url);
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        apply(c.getAttribute('data-insp-chip'), true);
      });
    });

    function restore() {
      if (!root.isConnected) return;
      apply(new URL(window.location.href).searchParams.get('vehicle') || '', false);
    }
    window.addEventListener('popstate', restore);
    window.addEventListener('pageshow', restore);
    restore();
  }

  function boot() {
    document.querySelectorAll('[data-vfw-inspiration]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-vfw-inspiration]').forEach(init);
  });
})();
